package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Stable
import app.smartcoding.realrate.localization.EnStrings
import kotlinx.serialization.Serializable


@Serializable
@Stable
data class SettingsState(
    val theme: ThemeOption = ThemeOption.SYSTEM,
    val languageCode: LanguageCode = LanguageCode(EnStrings.code),
)